import React, { ChangeEvent, FC } from "react";
import { useTranslation } from "react-i18next";

import Select from "../../../../components/Select";
import { ROLE_LIST } from "./constants";
import Label from "../../../../components/Label";
import SearchInput from "../../../../components/SearchInput";
import { FilterSectionProps } from "./types";

import "./styles.scss";

export const FilterSection: FC<FilterSectionProps> = ({
  handleRoleChange,
  handleResetFilter,
  filterData,
  handleSearch,
  handleSearchSubmit,
}) => {
  const { t } = useTranslation();
  const onChangeRole = (e: ChangeEvent<HTMLSelectElement>) => {
    handleRoleChange(e.target.value);
  };

  const validateSearch = (value: string) => {
    return value.length >= 3 || value.length === 0;
  };

  return (
    <section className="ams-manage-user__filters">
      <div className="ams-filter-group ams-search-group">
        <Label className="ams-filters__label">{t("search")}</Label>
        <SearchInput
          className="mb-0"
          value={filterData.search.value}
          onSearchChange={handleSearch}
          onSearchSubmit={handleSearchSubmit}
          validate={validateSearch}
        />
      </div>

      <div className="ams-filter-group">
        <Label className="ams-filters__label">{t("role")}</Label>
        <Select
          className="ams-manage-users-filters__select mb-0"
          value={filterData.role}
          onChange={onChangeRole}
        >
          {ROLE_LIST.map(({ label, value }) => {
            return (
              <option value={value} key={value}>
                {t(label.toLocaleLowerCase())}
              </option>
            );
          })}
        </Select>
      </div>

      <button
        className="ams-manage-users-filter-button"
        onClick={handleResetFilter}
      >
        {t("reset")}
      </button>
    </section>
  );
};
